import React from "react";
import { CreateAccountFormPreTest } from "../../components/CreateAccount/CreateAccountFormPreTest";

const CreateAccountPagePreTest: React.FC<{ setPathname: () => void }> = ({
  setPathname,
}) => <CreateAccountFormPreTest setPathname={setPathname} />;

export default CreateAccountPagePreTest;
